'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var dateInputComponent = require('./date-input-component-cce9256c.js');
var moment = _interopDefault(require('moment'));
var dateInputTitle = require('./date-input-title-93b678c0.js');

var CalendarInputContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var CalendarInput = function (_a) {
    var dataCy = _a.dataCy, value = _a.value, placeholder = _a.placeholder, hideOnDayClick = _a.hideOnDayClick, numberOfMonthsShown = _a.numberOfMonthsShown, disabled = _a.disabled, locale = _a.locale, dateTitle = _a.dateTitle, required = _a.required, errorText = _a.errorText, testId = _a.testId, readOnly = _a.readOnly, dateFormat = _a.dateFormat, minDate = _a.minDate, maxDate = _a.maxDate, onDateChange = _a.onDateChange;
    var formatDate = React.useCallback(function (date, format, localedate) {
        moment.locale(localedate);
        return moment(date).format(format);
    }, []);
    var parseDate = React.useCallback(function (str, format) {
        var parsed = moment(str, format);
        if (parsed instanceof Date) {
            return parsed;
        }
        return undefined;
    }, []);
    return (React__default.createElement(CalendarInputContainer, null,
        React__default.createElement(dateInputTitle.CalendarInputTitle, { dateTitle: dateTitle, required: required, readOnly: readOnly }),
        React__default.createElement(dateInputComponent.CalendarInputField, { dataCy: dataCy, required: required, testId: testId, formatDate: formatDate, parseDate: parseDate, hideOnDayClick: hideOnDayClick, placeholder: placeholder, value: value, initialMonth: value ? new Date(value) : undefined, numberOfMonthsShown: numberOfMonthsShown, disabled: disabled, locale: locale, onDateChange: onDateChange, errorText: errorText, readOnly: readOnly, dateFormat: dateFormat, minDate: minDate, maxDate: maxDate })));
};
var templateObject_1;

exports.CalendarInput = CalendarInput;
